import angular from 'angular';
import { TopbarComponent } from './topbar.component';
import './topbar.scss';

export * from './topbar.component';

export default angular.module('spa.widgets.topbar', [
  'spa.i18n'
])
  .config(config)
  .component(TopbarComponent.selector, TopbarComponent)
  .name;

config.$inject = [];

function config() {

}


// WEBPACK FOOTER //
// ./src/components/topbar/index.js